import { InvestmentEntityDocumentTypeEnumType } from '__generated__/graphql';

export default function investmentEntityDocumentTypeToReadable(
  type: InvestmentEntityDocumentTypeEnumType
): {
  label: string;
  color: string;
} {
  switch (type) {
    case InvestmentEntityDocumentTypeEnumType.UnitStatement:
      return {
        label: 'Unit Statement',
        color: 'indigo',
      };
    case InvestmentEntityDocumentTypeEnumType.DistributionStatement:
      return {
        label: 'Distribution Statement',
        color: 'green',
      };
    case InvestmentEntityDocumentTypeEnumType.SchemeInformationDocument:
      return {
        label: 'Scheme Information Document',
        color: 'yellow',
      };
    case InvestmentEntityDocumentTypeEnumType.ClosingDocument:
      return {
        label: 'Closing Document',
        color: 'black',
      };
    case InvestmentEntityDocumentTypeEnumType.ContributionAgreement:
      return {
        label: 'Contribution Agreement',
        color: 'purple',
      };
    case InvestmentEntityDocumentTypeEnumType.Form_64C:
      return {
        label: 'Form 64C',
        color: 'sky',
      };
    case InvestmentEntityDocumentTypeEnumType.InvestorStatement:
      return {
        label: 'Investor Statement',
        color: 'indigo',
      };
    case InvestmentEntityDocumentTypeEnumType.Kyc:
      return {
        label: 'KYC',
        color: 'amber',
      };
    case InvestmentEntityDocumentTypeEnumType.Other:
      return {
        label: 'Other',
        color: 'gray',
      };
    default:
      return {
        label: type,
        color: 'gray',
      };
  }
}
